<template>
  <td
    v-bind="$attrs"
    :class="{
      'table_cell--sticky-first': first,
      'table_cell--sticky-last': last,
      'table_cell--invalid': isInvalid,
    }"
  >
    <div class="sticky_table_cell" v-line-clamp="3">
      <span class="table_cell--invalid_message" v-if="!!invalidMessage">
        {{ invalidMessage }}</span
      >
      <slot v-else></slot>
    </div>
  </td>
</template>

<script>
export default {
  name: "StickyTableCell",
  props: {
    first: {
      type: Boolean,
      default: false,
    },
    last: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    invalidMessage: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";
@import "~include-media";

td {
  margin: 0;
  border: 0;
  font: inherit;
  vertical-align: middle;
  padding: 10px 24px 12px;
  max-width: 290px;

  .sticky_table_cell {
    word-break: break-word !important; // to override v-line-clamp directive's styling
  }

  &.table_cell--sticky-first {
    position: sticky;
    z-index: 2;
    left: 0;
    background-color: white;
    padding-left: 24px;
  }

  &.table_cell--sticky-last {
    position: sticky;
    z-index: 2;
    right: 0;
    background-color: white;
    padding-right: 24px;
  }

  &.table_cell--invalid {
    color: $red;
  }
}

.table_cell--invalid_message {
  font-weight: 600;
}
</style>
